import { render, staticRenderFns } from "./ClubDetailInfoBanner.vue?vue&type=template&id=3b417e89&scoped=true&"
import script from "./ClubDetailInfoBanner.vue?vue&type=script&lang=js&"
export * from "./ClubDetailInfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./ClubDetailInfoBanner.vue?vue&type=style&index=0&id=3b417e89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b417e89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b417e89')) {
      api.createRecord('3b417e89', component.options)
    } else {
      api.reload('3b417e89', component.options)
    }
    module.hot.accept("./ClubDetailInfoBanner.vue?vue&type=template&id=3b417e89&scoped=true&", function () {
      api.rerender('3b417e89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/core/ClubDetailInfoBanner/ClubDetailInfoBanner.vue"
export default component.exports